import {
    QUERY_GET_SUPPLIER_PRICINGS_BY_SUPPLIER,
    QUERY_GET_SUPPLIER_PRICING_BY_ID,
    QUERY_POST_CREATE_SUPPLIER_PRICING,
    QUERY_PUT_EDIT_SUPPLIER_PRICING,
    QUERY_DELETE_SUPPLIER_PRICING
} from '../../fetch/constantQueries';
import { baseThunk } from '../../fetch/basicThunk';

export const getSupplierPricings = baseThunk('supplierPricing/getBySupplier', QUERY_GET_SUPPLIER_PRICINGS_BY_SUPPLIER, 'GET');
export const getSupplierPricingById = baseThunk('supplierPricing/getById', QUERY_GET_SUPPLIER_PRICING_BY_ID, 'GET');
export const createSupplierPricing = baseThunk('supplierPricing/create', QUERY_POST_CREATE_SUPPLIER_PRICING, 'POST');
export const editSupplierPricing = baseThunk('supplierPricing/update', QUERY_PUT_EDIT_SUPPLIER_PRICING, 'PUT');
export const deleteSupplierPricing = baseThunk('supplierPricing/delete', QUERY_DELETE_SUPPLIER_PRICING, 'DELETE');
